<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>Unpublish advert</h2>
        </template>
        <template v-slot:body>
            <p>
                <strong>Why are you unpublishing this advert?</strong>
            </p>
            <div class="form-group">
                <div v-for="(reason, key) in ad.unpublish_reasons" :key="key">
                    <label>
                        <input
                            type="radio"
                            name="unpublished_reason"
                            ref="reason"
                            :value="key"
                            v-model="formData.unpublished_reason"
                            v-validate.persist="'required'"
                            data-vv-as="unpublished reason"
                            @change="onChangeReason"
                        >
                        {{ reason }}
                    </label>
                </div>
                <div class="form-error">{{ errors.first('unpublished_reason') }}</div>
            </div>
            <div class="form-group" v-if="showReasonDescription">
                <textarea
                    name="unpublished_reason_description"
                    class="form-control"
                    :class="{'has-error': errors.first('unpublished_reason_description') }"
                    v-model="formData.unpublished_reason_description"
                    v-validate.persist="`max:150|required_if:reason,${ad.unpublish_reasons.length - 1}`"
                    data-vv-as="reason"
                ></textarea>
                <div class="form-error">{{ errors.first('unpublished_reason_description') }}</div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    @click.prevent="onUnpublish"
                >
                    Unpublish
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        ad: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                slug: this.ad.slug,
                unpublished_reason: '',
                unpublished_reason_description: '',
            },
            showReasonDescription: false,
        };
    },
    updated() {
        if (this.showModal) {
            this.formData = {
                slug: this.ad.slug,
                unpublished_reason: '',
                unpublished_reason_description: '',
            };
            this.showReasonDescription = false;
        }
        this.$validator.reset();
    },
    methods: {
        onUnpublish() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.$emit('unpublished', this.formData);
                    this.$emit('close');
                }
            });
        },
        onCancel() {
            this.$emit('close');
        },
        onChangeReason(event) {
            this.showReasonDescription = parseFloat(event.target.value) === this.ad.unpublish_reasons.length - 1
                || parseFloat(event.target.value) === this.ad.unpublish_reasons.length - 2;
            if (!this.showReasonDescription) {
                this.formData.unpublished_reason_description = '';
            }
        },
    },
};
</script>
